import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { c } from 'ttag'
import YumSmallSelect from '../YumSmallSelect/YumSmallSelect'
import { isRtl } from '../../i18nInit'
import YumMediumSelect from '../YumMediumSelect/YumMediumSelect'

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'relative',
    display: 'inline-block',
    lineHeight: '1',
    verticalAlign: 'bottom',
    '& .Mui-disabled': {
      opacity: 0.5,
    },
  },
}))

export interface IYumAvgSumFilterProps {
  groupSum: boolean
  setGroupSumFilter(groupSum: boolean): any
  /** When true, uses outlined variant and removes margin */
  outline?: boolean
}

export default function YumAvgSumFilter(props: IYumAvgSumFilterProps) {
  const classes = useStyles()
  const [groupSum, setGroupSum] = React.useState(props.groupSum)

  React.useEffect(() => {
    setGroupSum(props.groupSum)
  }, [props.groupSum])

  const handleGroupSumChange = (event: React.ChangeEvent<any>) => {
    const { value } = event.target as { value: string }
    const val = value === 'true'
    setGroupSum(val)
    props.setGroupSumFilter(val)
  }

  // Determine style based on outline prop - no margin when outlined
  const selectStyle = props.outline ? {} : isRtl ? { marginRight: '10px' } : { marginLeft: '10px' }

  return (
    <div className={classes.root}>
      <YumSmallSelect
        style={selectStyle}
        color="primary"
        variant={props.outline ? 'outlined' : undefined}
        value={groupSum + ''}
        onChange={handleGroupSumChange}
        disabled={props.outline}
      >
        <option value={'false'}>{c('short').t`AVG`}</option>
        <option value={'true'}>{c('short').t`SUM`}</option>
      </YumSmallSelect>
    </div>
  )
}
